import { render, staticRenderFns } from "./metricas_crm.vue?vue&type=template&id=128d9341"
import script from "./metricas_crm.vue?vue&type=script&lang=js"
export * from "./metricas_crm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports